import React, { useContext } from "react";
import { useParams, useHistory } from "react-router-dom";
import { confirmDeletePost, fetchPut } from "../../utils";
import { MainContext } from "../../context/main";
import { usePostTags, useCurrentPost } from "../../hooks";
import { Title, Editor } from "..";
import EditTags from "./edit-tags";
import TagSelect from "./tag-select";

export default function Edit() {
  const { id: postId } = useParams();
  const history = useHistory();
  const { mainStore } = useContext(MainContext);
  const {
    hideDelete,
    title,
    isPublic,
    content,
    path,
    rawContent,
    updatePost,
    fetchData,
  } = useCurrentPost();

  const { deleteTagFromPost } = usePostTags();

  const confirmDelete = async () => {
    await confirmDeletePost(postId);
    history.push("/home");
  };

  const cancel = async () => {
    history.push(path || "/home");
  };

  const submit = async ({ push = true }) => {
    const { body } = await fetchPut({
      data: {
        ...mainStore.currentPost,
        content,
        title,
        isPublic,
      },
      onError: console.error,
      url: "/api/wiki",
    });
    await fetchData({ showEditButton: true });
    await handleSubmit({ body, push });
  };

  const handleSubmit = ({ body, push }) => {
    if (body && push) {
      history.push(body.path);
    }
  };

  return (
    <>
      <Title title={title} />

      <h1>
        Editing <em>"{title || ""}"</em>
      </h1>
      <p>
        <input
          checked={isPublic}
          onChange={({ target: { checked } }) => {
            updatePost({ isPublic: checked });
          }}
          id="page-public"
          type="checkbox"
        />{" "}
        <label htmlFor="page-public">Make this post public?</label>{" "}
      </p>
      <div>
        <TagSelect />
        <EditTags
          deleteTag={async (tagName) => {
            const { body } = await deleteTagFromPost(tagName);
            if (body) {
              updatePost(body);
            }
          }}
        />
      </div>
      <label htmlFor="page-title">Page name</label>
      <input
        autoFocus
        value={title}
        onChange={({ target: { value } }) => {
          updatePost({ title: value });
        }}
        id="page-title"
        type="text"
      />
      <br />
      <Editor
        submit={() => null}
        defaultValue={content}
        defaultRawValue={rawContent}
        handleChange={(e) => {
          const {
            target: { value },
          } = e;
          updatePost({ htmlContent: value, mdContent: value });
        }}
      />
      <div className="edit-buttons">
        {!hideDelete ? (
          <button
            onClick={confirmDelete}
            className="button--delete"
            id="delete-btn"
          >
            Delete
          </button>
        ) : (
          <div />
        )}
        <button className="button--cancel" onClick={cancel} id="cancel-btn">
          Cancel
        </button>
        <button onClick={submit} id="submit-btn">
          Submit
        </button>
      </div>
    </>
  );
}
